/**
 * FikoFeatureHizliEkSekmeli — Uzun-bas hızlı menüsü için SEKMELİ sarmalayıcı.
 * Sekme 1 "Özellik": feature'ın kendi ek bileşeni (icBilesen — FikoFeatureHizliEk/FikoSketchHizliEk...).
 * Sekme 2 "Ağırlık & Ölçü": gövdenin malzeme/hacim/ağırlık (mevcut sistem) + bbox boyut + yüzey alanı.
 * Paylaşılan hızlı menüyü bozmaz: featureHizliMenu hizliMenu3DEk = bu bileşen yapar.
 */
import { Component, Input, ChangeDetectionStrategy, Type, signal } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'fiko-feature-hizli-ek-sekmeli',
  standalone: true,
  imports: [CommonModule, FormsModule, NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="fs">
    <div class="fs-tab">
      <button class="fs-tb" [class.aktif]="sekme()==='ozellik'" (click)="sekme.set('ozellik')">⚙️ Özellik</button>
      <button class="fs-tb" [class.aktif]="sekme()==='olcu'" (click)="sekme.set('olcu')">⚖️ Ağırlık & Ölçü</button>
    </div>
    <div class="fs-ic">
      @if (sekme()==='ozellik') {
        @if (icBilesen) { <ng-container *ngComponentOutlet="icBilesen; inputs: { element: element, yonetici: yonetici }" /> }
      } @else if (!lisansli()) {
        <div class="fs-kilit">🔒<div class="fs-kilit-b">Ağırlık & Ölçü kilitli</div><div class="fs-kilit-s">Bu özellik ayrı lisanslıdır. Erişim için yöneticinizle görüşün.</div></div>
      } @else {
        @if (bilgi(); as b) {
          <div class="fs-grid">
            <label class="fs-malz">Malzeme
              <select [ngModel]="yonetici?.aktifMalzemeAd" (ngModelChange)="malzemeSec($event)">
                @for (m of yonetici?.malzemeListesi || []; track m.ad) { <option [value]="m.ad">{{ m.ad }}</option> }
              </select>
            </label>
            <div class="fs-rozet fs-vurgu"><small>Ağırlık{{ b.govdeAdet > 1 ? ' (' + b.govdeAdet + ' gövde)' : '' }}</small><b>{{ agirlikStr(b.agirlikG) }}</b></div>
            <div class="fs-rozet"><small>Hacim</small><b>{{ b.hacimCm3 }} cm³</b></div>
            @if (olcu(); as o) {
              <div class="fs-rozet"><small>Boyut (mm)</small><b>{{ o.x }}×{{ o.y }}×{{ o.z }}</b></div>
              <div class="fs-rozet"><small>Yüzey</small><b>{{ o.alanCm2 }} cm²</b></div>
            }
            <button class="fs-takip" (click)="parcaTakip()">📦 Bu parçayı takibe al</button>
          </div>
        } @else {
          <button class="fs-takip" (click)="parcaTakip()">📦 Parça takibi aç</button>
          <div class="fs-bos">Ağırlık/ölçü için katı bir gövde gerekli; takip yine de açılabilir.</div>
        }
      }
    </div>
  </div>
  `,
  styles: [`
    .fs{pointer-events:all;background:rgba(0,90,90,.82);border:1px solid rgba(127,255,255,.3);border-radius:10px;box-shadow:0 0 14px rgb(0 255 255 / 40%);padding:5px;min-width:210px;max-width:280px;color:#eaffff;font:600 11px system-ui;}
    .fs-tab{display:flex;gap:4px;margin-bottom:5px;}
    .fs-tb{flex:1;background:rgba(0,40,50,.5);border:1px solid rgba(127,255,255,.2);color:#bdf3ff;border-radius:7px;padding:4px 6px;font-size:10px;font-weight:700;cursor:pointer;transition:.15s;}
    .fs-tb.aktif{background:rgba(0,200,220,.9);color:#012;border-color:#0ff;box-shadow:0 0 8px rgb(0 255 255 / 50%);}
    .fs-tb:hover{filter:brightness(1.15);}
    .fs-grid{display:flex;flex-wrap:wrap;gap:5px;}
    .fs-malz{flex:1 1 100%;display:flex;flex-direction:column;gap:2px;font-size:9px;color:#9fe9ff;}
    .fs-malz select{background:rgba(0,30,40,.7);border:1px solid rgba(127,255,255,.3);color:#fff;border-radius:5px;padding:3px 5px;font-size:11px;outline:none;}
    .fs-rozet{flex:1 1 calc(50% - 3px);display:flex;flex-direction:column;gap:1px;background:rgba(0,40,50,.55);border:1px solid rgba(127,255,255,.15);border-radius:7px;padding:5px 8px;}
    .fs-rozet small{font-size:8px;color:#8fdce8;text-transform:uppercase;letter-spacing:.04em;}
    .fs-rozet b{font-size:13px;font-weight:800;color:#fff;}
    .fs-vurgu{background:rgba(0,200,160,.22);border-color:rgba(0,255,200,.5);}
    .fs-vurgu b{color:#7dffd0;}
    .fs-takip{flex:1 1 100%;margin-top:3px;background:linear-gradient(135deg,#2563eb,#1d4ed8);border:1px solid #3b82f6;color:#fff;border-radius:7px;padding:7px;font-size:11px;font-weight:700;cursor:pointer;transition:.15s;}
    .fs-takip:hover{filter:brightness(1.15);}
    .fs-bos{font-size:10px;color:#bdf3ff;padding:8px;text-align:center;}
    .fs-kilit{text-align:center;padding:14px 8px;color:#bdf3ff;}
    .fs-kilit{font-size:22px;}.fs-kilit-b{font-size:12px;font-weight:800;margin-top:4px;color:#fff;}
    .fs-kilit-s{font-size:10px;color:#9fe9ff;margin-top:3px;line-height:1.3;}
  `],
})
export class FikoFeatureHizliEkSekmeli {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() icBilesen?: Type<any>;
  sekme = signal<'ozellik' | 'olcu'>('ozellik');

  /** Uzun-bas ağırlık/ölçü lisansı — granüler komut (OLCUM:agirlik). Köprü yoksa AÇIK (geriye uyumlu). */
  lisansli(): boolean { try { return (window as any).__fikoModul?.('OLCUM', 'agirlik') ?? true; } catch { return true; } }
  bilgi() { return this.yonetici?.govdeBilgi || null; }
  olcu() { try { return this.yonetici?.govdeOlcu?.() || null; } catch { return null; } }
  agirlikStr(g: number): string { return g >= 1000 ? (g / 1000).toFixed(2) + ' kg' : Math.round(g) + ' g'; }
  malzemeSec(ad: string) { this.yonetici?.malzemeAta?.(ad); }
  parcaTakip() { this.yonetici?.parcaTakibiAc?.(); }
}
